import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Building2, RefreshCw } from "lucide-react";
import "./ListaSap.css";

import getCondominios from "../../API/condos/Condos";
import SapGrid from "../../features/listaSAP/SapGrid/SapGrid";
import PageHeader from "../../components/ui/PageHeader/PageHeader";
import ListToolbar from "../../components/ui/ListToolbar/ListToolbar";
import { redirectWithTokenAndCondo } from "../../utils/authRedirect";

export default function ListaSapPage() {
  const [condominios, setCondominios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [error, setError] = useState("");

  const loadCondominios = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const res = await getCondominios();
      const lista = res?.data?.condominios ?? res?.data?.urls ?? [];
      setCondominios(
        lista.filter((c) => (c?.name || "").toLowerCase() !== "all")
      );
    } catch (e) {
      setError("Não foi possível carregar a lista de SAP agora.");
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadCondominios();
  }, [loadCondominios]);

  const filtrados = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return condominios;
    return condominios.filter(
      (c) =>
        c?.name?.toLowerCase().includes(q) ||
        c?.app_url?.toLowerCase().includes(q)
    );
  }, [condominios, query]);

  const handleOpen = (condominio) => {
    try {
      const url = redirectWithTokenAndCondo({
        baseUrl: condominio.app_url,
        condominioId: condominio.id, // ajuste se o campo for outro
      });

      window.location.href = url;
    } catch (err) {
      alert("Erro ao abrir: faça login novamente ou tente outro condomínio.");
      console.error(err);
    }
  };

  return (
    <div className="listaSap-page">
      <PageHeader
        title="Lista de SAP"
        subtitle="Selecione um condomínio para abrir o servidor correspondente."
        icon={<Building2 strokeWidth={1.8} />}
        iconVariant="green"
        rightContent={
          <>
            <button
              type="button"
              className="listaSap-refresh-btn"
              onClick={loadCondominios}
              disabled={loading}
            >
              <RefreshCw
                className={
                  loading
                    ? "listaSap-refresh-icon spinning"
                    : "listaSap-refresh-icon"
                }
                strokeWidth={1.8}
              />
              <span>{loading ? "Atualizando..." : "Atualizar lista"}</span>
            </button>

            <ListToolbar
              value={query}
              onChange={setQuery}
              searchPlaceholder="Buscar por nome ou domínio..."
            />

            <span className="listaSap-counter">
              {loading
                ? "Carregando..."
                : `${filtrados.length} de ${condominios.length}`}
            </span>
          </>
        }
      />

      {error && <div className="listaSap-error">{error}</div>}

      <main className="listaSap-content">
        <SapGrid itens={filtrados} loading={loading} onOpen={handleOpen} />
      </main>
    </div>
  );
}
